import moment from "moment";
import "moment-timezone";

// The only 8 TimeZone rows with ActiveYn = 1 in HaasMaster today (see
// HaasDatabase/HaasMaster/postdeploy_manual/Script.TimeZone.sql). These are non-standard shortened
// names, not canonical .NET TimeZoneInfo IDs -- an off-the-shelf Windows->IANA table wouldn't match
// them anyway. Extend this if a new TimeZone row is ever activated.
const WINDOWS_TZ_NAME_TO_IANA: Record<string, string> = {
    Alaskan: "America/Anchorage",
    Arizona: "America/Phoenix",
    Atlantic: "America/Puerto_Rico",
    Central: "America/Chicago",
    Eastern: "America/New_York",
    Hawaiian: "Pacific/Honolulu",
    Mountain: "America/Denver",
    Pacific: "America/Los_Angeles",
};

// Falls back to the browser's guessed timezone when the name is unrecognized or empty (e.g. a
// TimeZoneGuid that didn't resolve to an active TimeZone row)
export const getAccountTimeZoneIana = (timeZoneName: string): string => {
    return WINDOWS_TZ_NAME_TO_IANA[timeZoneName] ?? moment.tz.guess();
};

export const formatInAccountTimeZone = (utcIso: string, iana: string, format: string): string => {
    return moment(utcIso).tz(iana).format(format);
};
